import * as CarbonComponents from '@carbon/react';
export const Header = CarbonComponents.Header;
export const HeaderName = CarbonComponents.HeaderName;
export const HeaderGlobalBar = CarbonComponents.HeaderGlobalBar;
export const HeaderNavigation = CarbonComponents.HeaderNavigation;
export const HeaderGlobalAction = CarbonComponents.HeaderGlobalAction;
export const HeaderPanel = CarbonComponents.HeaderPanel;
export const HeaderMenuButton = CarbonComponents.HeaderMenuButton;
